import { TemplatePlaceholder } from '@/types';
import { DEFAULT_PLACEHOLDER_FIELD_LABEL } from '@/constants/searchTemplate';

export function createTemplatePlaceholder(
  title = DEFAULT_PLACEHOLDER_FIELD_LABEL,
  description = '',
  optional = false
): TemplatePlaceholder {
  return { placeholder: { title, description, optional } };
}
